import React from 'react'
import { Typography, makeStyles } from '@material-ui/core'
import { Box, Card } from '@mui/material'
import { useSelector } from 'react-redux'
import { Letters } from '../constants/index'
import { round } from 'lodash'

const PollQuestion = ({ question }) => {
  const classes = useStyles()
  const { answers } = useSelector((state) => state.polling)

  const questionAnswers = answers.find((doc) => doc.questionId === question?.id)?.answers || []

  const optionsPercentage = question?.options?.map((option) => {
    const optionVotes = questionAnswers?.filter((doc) => doc?.optId === option?.optId)
    const optionCount = optionVotes?.length ?? 0
    const totalAnswers = questionAnswers?.length ?? 0
    return { optId: option.optId, vote: totalAnswers > 0 ? (optionCount * 100) / totalAnswers : 0 }
  })

  const getVotePercentageOfOption = (selectedOption) => {
    const foundOption = optionsPercentage.find(({ optId }) => optId === selectedOption)
    return foundOption ? round(foundOption?.vote, 0) : 0
  }

  return (
    <Card elevation={0} className={classes.card}>
      <Typography className={classes.question}>{question?.title}</Typography>
      <Box className={classes.options}>
        {question?.options.map((option, idx) => {
          const optionPercentage = getVotePercentageOfOption(option?.optId)
          return (
            <Box key={option.optId}>
              <Box>
                <Typography className={classes.option}>
                  <span className={classes.index}>{Letters[idx]}.</span>
                  <span> {option.opt}</span>
                </Typography>
              </Box>
              <Box className={classes.customProgress}>
                {optionPercentage === 0 ? (
                  <Box className={classes.emptyProgress}>
                    <Typography className={classes.percentage}>{optionPercentage}%</Typography>
                  </Box>
                ) : (
                  <Box className={classes.filled} style={{ width: `${optionPercentage}%` }}>
                    <Typography className={classes.percentageValue}>{optionPercentage}%</Typography>
                  </Box>
                )}
              </Box>
            </Box>
          )
        })}
      </Box>
    </Card>
  )
}

export default PollQuestion

const useStyles = makeStyles((theme) => ({
  card: {
    width: '600px',
    padding: '14px 32px',
    border: '1px solid #bdbdbd',
    borderRadius: '12px',
    height: 'fit-content',
    [theme.breakpoints.up('md')]: {
      width: '1000px'
    },
    [theme.breakpoints.up('lg')]: {
      width: '1200px'
    },
    [theme.breakpoints.up('xl')]: {
      width: '1300px'
    }
  },
  question: {
    fontSize: '28px',
    fontWeight: '600'
  },
  index: {
    fontWeight: '600',
    marginLeft: '2px',
    marginRight: '4px'
  },
  options: {
    marginTop: '20px',
    marginLeft: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  option: {
    fontSize: '22px'
  },
  customProgress: {
    marginTop: '2px',
    pointerEvents: 'none',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#e3f2fd'
  },
  emptyProgress: {
    width: '100%',
    display: 'flex',
    transition: 'width 0.6s ease',
    alignItems: 'center',
    justifyContent: 'center'
  },
  filled: {
    height: '50px',
    backgroundColor: '#2196f3',
    transition: 'width 0.6s ease',
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center'
  },
  percentageValue: {
    marginRight: '4px',
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  percentage: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#111111'
  }
}))
